import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('deployView');
const type = createActionType('deployView');

export const OPEN_DEPLOY_DIALOG = type('OpenDeployDialog');
export const CLOSE_DEPLOY_DIALOG = type('CloseDeployDialog');

export const DEPLOY_AS_TABLE = apiType('DeployAsTable');
export const DEPLOY_AS_VIEW = apiType('DeployAsView');

export const PAUSE_SNOWFLAKE_OUTPUT = apiType('PauseSnowflakeOutput');
export const RESUME_SNOWFLAKE_OUTPUT = apiType('ResumeSnowflakeOutput');

export const SAVE_TRIGGER = apiType('SaveTrigger');
export const EDIT_TRIGGER = type('EditTrigger');
export const CANCEL_EDIT_TRIGGER = type('CancelEditTrigger');

export const SHOW_HISTORY_DIALOG = type('ShowHistoryDialog');
export const CLOSE_HISTORY_DIALOG = type('CloseHistoryDialog');
export const GET_HISTORY = apiType('GetHistory');
